import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginView from './views/LoginView';
import QRCodeLoginView from './views/QRCodeLoginView';
import EventModeView from './views/EventModeView';
import ScanView from './views/ScanView';
import AccountView from './views/AccountView';
import { HistoryView } from './views/HistoryView';
import PrivateRoute from './router/privateRoute';
import ConfiguredRoute from './router/configuredRoute';
import { primeAudio } from './services/soundService';

function App() {
  // Les navigateurs mobiles n'autorisent la lecture audio qu'après une
  // interaction : on débloque le contexte au tout premier appui, une fois.
  useEffect(() => {
    const events = ['pointerdown', 'touchend', 'keydown'];
    const unlock = () => {
      primeAudio();
      events.forEach((event) => window.removeEventListener(event, unlock));
    };
    events.forEach((event) => window.addEventListener(event, unlock, { passive: true }));
    return () => events.forEach((event) => window.removeEventListener(event, unlock));
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="login" element={<LoginView />} />
        <Route path="qrlogin" element={<QRCodeLoginView />} />
        <Route element={<PrivateRoute />}>
          <Route path="mode" element={<EventModeView />} />
          <Route element={<ConfiguredRoute />}>
            <Route path="scan" element={<ScanView />} />
            <Route path="user-history" element={<HistoryView />} />
            <Route path="settings" element={<AccountView />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="scan" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
